import selectors from "@/lib/selectors";

export default function ({ available }) {
  const section = this.container;

  const btn = section.querySelector(selectors.product.addButton);
  const text = btn.querySelector(selectors.product.addButtonText);

  const { langAvailable, langSoldOut } = btn.dataset;

  if (available) {
    btn.removeAttribute("disabled");
    text.textContent = langAvailable;
  } else {
    btn.setAttribute("disabled", "disabled");
    text.textContent = langSoldOut;
  }
}
